export default "__VITE_ASSET__Ln1WaUmX__"